module.exports = __webpack_public_path__ + "fonts/DINPro.c1c2a1aa.ttf";